import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=6709fb61&scoped=true"
import script from "./DetailInfo.vue?vue&type=script&lang=js"
export * from "./DetailInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=6709fb61&prod&lang=less&scoped=true"
import style1 from "./DetailInfo.vue?vue&type=style&index=1&id=6709fb61&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6709fb61",
  null
  
)

export default component.exports